import { useMemo } from 'react';
import { Box } from '../UI-CHAKRA/Box';
import { usePrescriptionStore } from '../../stores/prescriptionStore';
import { Flex } from '../UI-CHAKRA/Flex';
import { Text } from '../UI-CHAKRA/Text';
import { LogoImg } from '../../containers/certificate/CertificateCard';

export default function SigningInIHRFlow() {
  const { prescriberConfiguration } = usePrescriptionStore();

  const certificate = useMemo(() => {
    return {
      name: prescriberConfiguration?.Nome || '',
      imagePath: prescriberConfiguration?.LogoUrl || null,
    };
  }, [prescriberConfiguration?.LogoUrl, prescriberConfiguration?.Nome]);

  return (
    <Box bgColor="white" borderRadius="20px" p="10px">
      <Flex width="100%" px="20px" gap="10px" justifyContent="center" alignItems="center">
        {certificate.imagePath ? (
          <LogoImg src={certificate.imagePath} alt={certificate.name} />
        ) : (
          <Text textAlign={'center'} fontSize={'12px'} dangerouslySetInnerHTML={{ __html: certificate.name }} />
        )}
        <Flex flex={1} flexDir="column" alignItems="flex-start">
          <Text align={'center'} fontSize={'12px'} lineHeight={'16px'} fontWeight={700}>
            Método de assinatura:
          </Text>
          <Text align={'center'} fontSize={'12px'} lineHeight={'16px'} data-testid="selected-certificate">
            {certificate.name.replace('</br>', '')}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
}
